import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/storybook-components';
import style from './style.module.scss';
/**
 * SkipTourButton
 *  - Skip button for Tour Components
 */
export function SkipTourButton(props) {
  const className = `${style.button} ${props.className}`;

  return (
    <>
      {props.visible ? (
        <Button
          type={'secondary'}
          onClick={props.onClick}
          className={className}>
          {props.buttonText}
        </Button>
      ) : null}
    </>
  );
}

SkipTourButton.propTypes = {
  /**
   * Callback function involked on button Click
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Boolean specifying if SkipTourButton is visible
   */
  visible: PropTypes.bool,
  /**
   * Shows the label for button
   */
  buttonText: PropTypes.string,
};

SkipTourButton.defaultProps = {
  visible: true,
  buttonText: 'Skip tour',
  className: '',
};
